var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_1117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8231 9.16064H4.164C3.24412 9.16064 2.49841 9.90636 2.49841 10.8262V16.6558C2.49841 17.5757 3.24412 18.3214 4.164 18.3214H15.8231C16.743 18.3214 17.4887 17.5757 17.4887 16.6558V10.8262C17.4887 9.90636 16.743 9.16064 15.8231 9.16064Z",
    stroke: "#4F39F6",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82959 9.16069V5.82951C5.82959 4.72515 6.26829 3.66603 7.04919 2.88513C7.83009 2.10423 8.88921 1.66553 9.99357 1.66553C11.0979 1.66553 12.157 2.10423 12.9379 2.88513C13.7188 3.66603 14.1575 4.72515 14.1575 5.82951V9.16069",
    stroke: "#4F39F6",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_1117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9871,
    height: 19.9871,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6226d6343ba7a538200059d7db55aadf.svg";
export { ForwardRef as ReactComponent };